import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiClient } from 'Utils/api';
import { getDeliveryCountry, setDeliveryCountry } from 'Utils/deliveryCountry';

interface CountryOption {
  code: string;
  ratePermille: number;
}

interface CountryContextValue {
  country: string;
  setCountry: (code: string) => void;
  countries: CountryOption[];
}

const CountryContext = createContext<CountryContextValue>({
  country: 'DE',
  setCountry: () => {},
  countries: [],
});

export const useCountry = () => useContext(CountryContext);

export const CountryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [country, setCountryState] = useState<string>(getDeliveryCountry());
  const [countries, setCountries] = useState<CountryOption[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiClient.get('/api/tax-rates');
        const list: CountryOption[] = res.data?.countries || [];
        setCountries(list);
        // If the persisted country is not in the configured list, fall back to DE.
        if (list.length > 0 && !list.some((c) => c.code === getDeliveryCountry())) {
          setDeliveryCountry('DE');
          setCountryState('DE');
        }
      } catch {
        /* selector just stays minimal */
      }
    })();
  }, []);

  const setCountry = useCallback((code: string) => {
    setDeliveryCountry(code);
    setCountryState(code.toUpperCase());
  }, []);

  return (
    <CountryContext.Provider value={{ country, setCountry, countries }}>
      {children}
    </CountryContext.Provider>
  );
};
